import ContainerPage from "../../../components/ContainerPage/ContainerPage"
import React, { useState } from "react"
import AddTask from "../../../components/TasksTab/AddTask"
import EditTask from "../../../components/TasksTab/EditTask"
import AllTasksPage from "./AllTasksPage"

const TasksPage = () => {
  const [activeTab, setActiveTab] = useState('tasks')
  const [taskId, setTaskId] = useState('')
  const [isUpdated, setIsUpdated] = useState(false)

  return (
    <div className="">
      <ContainerPage>
        {activeTab === "tasks" && <AllTasksPage setActiveTab={setActiveTab} setTaskId={setTaskId} setIsUpdated={setIsUpdated} isUpdated={isUpdated}/>}
        {activeTab === "addTask" && <AddTask setActiveTab={setActiveTab} isTasksPage={true}/>}
        {activeTab === "editTask" && <EditTask setActiveTab={setActiveTab} taskId={taskId} isTasksPage={true} setIsUpdated={setIsUpdated} isUpdated={isUpdated}/>}
      </ContainerPage>
    </div>
  )
}
export default TasksPage